const questionIcon = require("../assets/media/question.png");
const experienceIcon = require("../assets/media/Experience.png");
const ideaIcon = require("../assets/media/Idea.png");
const milestoneIcon = require("../assets/media/Milestone.png");
const helpIcon = require("../assets/media/help.png");
const memoryIcon = require("../assets/media/feeds/memory.png");
const articleIcon = require("../assets/media/feeds/article.png");
const imageIcon = require("../assets/media/feeds/image.png");
const gifIcon = require("../assets/media/feeds/gif.png");
const videoIcon = require("../assets/media/feeds/video.png");
const youtubeIcon = require("../assets/media/youtube.png");
const pdfIcon = require("../assets/media/pdf.png");
const tokenOffersIcon = require("../assets/media/community_tabs/token-offers.png");
const discountOffersIcon = require("../assets/media/community_tabs/discount.png");
const earnTokensIcon = require("../assets/media/community_tabs/chip.png");
const messagesIcon = require("../assets/media/community_tabs/connection.png");
const myIdIcon = require("../assets/media/community_tabs/security.png");
const feedsIcon = require("../assets/media/community_tabs/forum.png");
const pollsIcon = require("../assets/media/community_tabs/opinion.png");
const shopIcon = require("../assets/media/community_tabs/shop.png");
const ecopayIcon = require("../assets/media/community_tabs/pay.png");
const friendsIcon = require("../assets/media/community_tabs/eco-friendly.png");
const conciergeIcon = require("../assets/media/community_tabs/concierge.png");
const tokenWalletIcon = require("../assets/media/community_tabs/token_wallet.png");
const cardWalletIcon = require("../assets/media/community_tabs/wallet.jpg");
const bankingWalletIcon = require("../assets/media/community_tabs/pay.png");
const timelineIcon = require("../assets/media/community_tabs/timeline.png");
const newchatIcon = require("../assets/media/community_tabs/support.png");
const ticketsIcon = require("../assets/media/community_tabs/ticket.png");
const ecosystemIcon = require("../assets/media/community_tabs/ecosystem.png");
const exploreIcon = require("../assets/media/community_tabs/ecosystem-token-centered.png");
const tokenPayIcon = require("../assets/media/community_tabs/tokenPay.png");
const eventsIcon = require("../assets/media/community_tabs/event.png");
const reviewsIcon = require("../assets/media/community_tabs/review.png");
const savingIcon = require("../assets/media/community_tabs/saving.png");
const iframeIcon = require("../assets/media/community_tabs/iframe.png");
const magazineIcon = require("../assets/media/community_tabs/magazine.png");
const hotIcon = require("../assets/media/community_tabs/fire.png");
const surveyIcon = require("../assets/media/community_tabs/browser.png");
const PoundCoin = require("../assets/media/coins/pound-coin.png");
const DollarCoin = require("../assets/media/coins/dollar-coin.png");
const EuroCoin = require("../assets/media/coins/euro-coin.png");
export const TypeIcon = {
  "A question": questionIcon,
  "An experience": experienceIcon,
  "An idea": ideaIcon,
  "A milestone": milestoneIcon,
  "Help needed": helpIcon,
  "A memory": memoryIcon,
  image_file: imageIcon,
  gif_file: gifIcon,
  video_file: videoIcon,
  youtube_url: youtubeIcon,
  "A article": articleIcon,
  pdf_file: pdfIcon,
};
export const ToolIcon = {
  tokenPay: tokenPayIcon,
  ecosystem: ecosystemIcon,
  concierge: conciergeIcon,
  tickets: ticketsIcon,
  newchat: newchatIcon,
  timeline: timelineIcon,
  myId: myIdIcon,
  tokenwallet: tokenWalletIcon,
  cardwallet: cardWalletIcon,
  bankwallet: bankingWalletIcon,
  friends: friendsIcon,
  feeds: feedsIcon,
  polls: pollsIcon,
  events: eventsIcon,
  messages: messagesIcon,
  reviews: reviewsIcon,
  ecopay: ecopayIcon,
  tokenOffers: tokenOffersIcon,
  discountOffers: discountOffersIcon,
  earnTokens: earnTokensIcon,
  shop: shopIcon,
  saving: savingIcon,
  iframe: iframeIcon,
  magazine: magazineIcon,
  hot: hotIcon,
  survey: surveyIcon,
  explore: exploreIcon,
};
export const coinIcon = {
  UK: PoundCoin,
  USA: DollarCoin,
  SouthAfrica: DollarCoin,
  Ireland: EuroCoin,
  German: EuroCoin,
  France: EuroCoin,
  Canada: DollarCoin,
  India: DollarCoin,
  Australia: DollarCoin,
};



// WEBPACK FOOTER //
// ./src/Constants/assets.js